export const projectSpace = {
  projectInspection: '项目验收',
  enterReasonForNotPassing: '请输入不通过原因',
  inspectionProgress: '验收进度',
  passOrNot: '【{name}】是否通过?',
  reasonForNotPassing: '不通过原因',
  satisfactionRating: '满意度打分',
  designSatisfaction: '设计满意度',
  constructionSatisfaction: '施工满意度',
  signature: '签名（点击图片可重签）',
  uploadImageOrVideo: '请上传图片或视频',
  pleaseSign: '请签名',
  inspectionReport: '验收报告',
  relatedImagesAndVideos: '相关的图片和视频',
  signature2: '签名',
  projectDetails: '项目详情',
  projectFunds: '项目款项',
  progressPlan: '进度计划',
  projectInfo: '项目信息',
  projectNameMaxLength: '项目名称最多30个字符',
  projectNameNotEmpty: '项目名称不能为空',
  enterProjectName: '请输入项目名称',
  communityName: '小区名称',
  enterCommunityName: '请输入小区名称',
  apartmentLayout: '户型',
  apartmentLayoutParams: `{room}室{drawing}厅{kitchen}厨{rest}卫`,
  apartmentArea: '套内面积',
  enterDesignerName: '请输入设计师名称',
  createTime: '创建时间',
  expirationDate: '到期日期',
  projectRemarks: '项目备注',
  select: '选择',
  allProjects: '全部项目',
  checkPassed: '验收通过（完成）',
  loading: '加载中',
  noConstructionProjects: '暂无施工项目',
  projectRole: '项目角色',
  projectStatus: '项目状态',
  overallProgress: '整体进度',
  paidAmount: '已付款金额',
  dataForReferenceOnly: '数据仅供参考，实际收款以财务数据为准',
  paymentRefundAmount: '付/退款金额',
  paymentDate: '付款日期',
  recordTransaction: '记一笔',
  enterPaymentName: '请输入款项名称',
  paymentNameMax20Chars: '款项名称最多输入20个字符',
  selectPaymentDate: '请选择付款日期',
  enterPaymentAmount: '请输入退/付款金额',
  paymentName: '款项名称',
  enterAmount: '请输入金额'
};
